// src/PauseIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var PauseIcon = ({ ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: "17",
    height: "17",
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M7.3 14.9997V2.35969C7.3 1.15969 6.79333 0.679688 5.51333 0.679688H2.28667C1.00667 0.679688 0.5 1.15969 0.5 2.35969V14.9997C0.5 16.1997 1.00667 16.6797 2.28667 16.6797H5.51333C6.79333 16.6797 7.3 16.1997 7.3 14.9997Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M16.5 14.9997V2.35969C16.5 1.15969 15.9933 0.679688 14.7133 0.679688H11.4867C10.2156 0.679688 9.7 1.15969 9.7 2.35969V14.9997C9.7 16.1997 10.2067 16.6797 11.4867 16.6797H14.7133C15.9933 16.6797 16.5 16.1997 16.5 14.9997Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
var PauseIcon_default = PauseIcon;

export {
  PauseIcon_default
};
